module.exports = __webpack_public_path__ + "static/media/home1.4b789bee.jpg";